import { Container, Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

function section({ title, children }) {
    return (
        <Box sx={{ py: 8, mt: 8 }}>
            <Container maxWidth="lg">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
                    <Typography variant="h3" component="h2" gutterBottom align="center" fontWeight="bold">
                        {title}
                    </Typography>
                    <Box sx={{ mt: 4 }}>
                        {children}
                    </Box>
                </motion.div>
            </Container>
        </Box>
    );
}

export default section